import { useFormikContext } from 'formik';

import { SelectArray } from 'hb-react/shared/components/formik/components/inputs';

import { type FormValues, type LinkedCompanyProps } from '../types';

export const LinkedCompany = () => {
  const { setFieldValue, values, setValues } = useFormikContext<FormValues>();

  const handleChange = (companyInfo?: LinkedCompanyProps) => {
    if (companyInfo && '__isNew__' in companyInfo) {
      setFieldValue('company_name', companyInfo.value);
      setFieldValue('company_id', null);
    } else if (companyInfo) {
      if (companyInfo.logo_url) {
        setValues({ ...values, logo_original_url: companyInfo.logo_url });
        setFieldValue('sync_to_org_logo', true);
      }
      setFieldValue('company_id', companyInfo.id);
    } else {
      setFieldValue('company_id', null);
      setFieldValue('company_name', null);
    }
  };

  return (
    <SelectArray
      id="company_id"
      label={s__('JobForm|Organization name')}
      isClearable
      name="company_id"
      placeholder={
        values.company_name ??
        s__('JobForm|Organization issuing the opportunity')
      }
      type="companies"
      onChange={handleChange}
      inputHtml={{
        formatCreateLabel: (text) => text, // removes the "Create" prefix
        creatable: true,
      }}
    />
  );
};
